/* 遵循ant-design-pro定义接口规范 */
/* https://github.com/ant-design/ant-design-pro */

import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { CompanyRegisterState, UserRegisterState } from "./interface/AuthInterface"

/** 企业认证注册接口 */
export async function authCompanyRegister(data: CompanyRegisterState): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/accounts/certifications/company', data)
}

/** 企业认证重新修改接口 */
export async function authCompanyEdit(data: CompanyRegisterState): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put('/v1/api/accounts/certifications/company', data)
}

/** 获取企业是否已认证 */
export async function authCompanyState(): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/accounts/certifications/company')
}

/** 个人认证注册 */
export async function authUserRegister(data: UserRegisterState): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/accounts/certifications/person', data)
}

/** 个人认证重新修改 */
export async function authUserEdit(data: UserRegisterState): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put('/v1/api/accounts/certifications/person', data)
}

/** 获取个人是否已认证 */
export async function authUserState(): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/accounts/certifications/person')
}

/** 图片上传接口 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function uploadImage(file: any): Promise<any> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/attachment/account', { fileBlob: file }, {
    download: false,
    loading: false,
    formData: false,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
